import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Post } from './types/post.type';

@Injectable({
  providedIn: 'root',
})
export class PostService {
  constructor(private http: HttpClient) {}

  getPosts() {
    return this.http.get<Post[]>(`/api/posts`);
  }

  getPost(post_id: string) {
    return this.http.get<Post>(`/api/posts/${post_id}`);
  }

  getDraft(post_id: string) {
    return this.http.get<Post>(`/api/posts/${post_id}/draft`);
  }

  updateDraft(post: Post) {
    return this.http.put<Post>(`/api/posts/${post.post_id}/draft`, post);
  }

  createPost(post: Post) {
    return this.http.post<Post>('/api/posts', post);
  }

  updatePost(post: Post) {
    return this.http.put<Post>(`/api/posts/${post.post_id}`, post);
  }

  publishPost(post: Post) {
    return this.http.post<{ success: boolean; message?: string }>(
      `/api/posts/${post.post_id}`,
      { publish: true, post_id: post.post_id }
    );
  }

  unpublishPost(post: Post) {
    return this.http.post<{ success: boolean; message?: string }>(
      `/api/posts/${post.post_id}`,
      { publish: false, post_id: post.post_id }
    );
  }

  deletePost(post_id: string) {
    return this.http.delete<{ success: boolean; message: string }>(
      `/api/posts/${post_id}`
    );
  }
}
